import gql from 'graphql-tag'

export const SEND_USER_MESSAGE = gql`
  mutation ($input: UserMessageRequestInput!) {
    sendUserMessage(input: $input) {
      status
      message
    }
  }
`

export const VALIDATE_EMAIL = gql`
  query validateEmail($email: String!) {
    validateEmail(email: $email) {
      success
      result
    }
  }
`

export const SIGN_OUT = gql`
  mutation signOut {
    signOut
  }
`
